<!--通用时间选择器-->
<template>
  <div class="ny-date-picker">
    <div class="ny-date-picker__header">
      <a class="ny-date-picker__btn ny-date-picker__prev" href="javascript:;" @click="changeMonth('prev')">&lt;</a>
      <span class="ny-date-picker__month">{{monthData.month}}月</span>
      <span class="ny-date-picker__year">{{monthData.year}}年</span>
      <a class="ny-date-picker__btn ny-date-picker__next" href="javascript:;" @click="changeMonth('next')">&gt;</a>
    </div>
    <div class="ny-date-picker__body">
      <table class="ny-date-picker__table">
        <thead class="ny-date-picker__thead">
          <tr>
            <th v-for="(week, index) in weeks" :key="index">{{week}}</th>
          </tr>
        </thead>
        <tbody class="ny-date-picker__tbody">
          <tr v-for="(days, i) in monthData.days" :key="i">
            <td
              v-for="(day, index) in days"
              :key="index"
              :class="{
                'is-last': day.month !== monthData.month,
                'is-disabled': isDisabled(day.fullDate)
              }"
              @click="selectDate(day.fullDate)"
            >
              <span
                :class="{
                  'is-start': dateType === 'start' && selectedDate === day.fullDate,
                  'is-end': dateType === 'end' && selectedDate === day.fullDate
                }"
              >{{day.showDate}}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NyDatePicker',
  props: {
    value: [String, Date],
    dateType: {
      type: String,
      default: 'start',
      validator: val => ['start', 'end'].indexOf(val) > -1
    },
    disabledDate: {
      type: Function,
      default: (time) => new Date(time) > Date.now()
    },
    associatedDate: [String, Date]
  },
  data () {
    return {
      weeks: ['一', '二', '三', '四', '五', '六', '日'],
      monthData: {
        year: '',
        month: '',
        days: []
      },
      selectedDate: ''
    };
  },
  created () {
    this.initData();
  },
  methods: {
    isDate (date) {
      return date && Object.prototype.toString.call(date) === '[object Date]'
    },
    compareDate (date1, date2) {
      return new Date(this.patchZero(date1)).getTime() > new Date(this.patchZero(date2)).getTime()
    },
    initData () {
      let date = this.value;

      if (this.associatedDate && this.compareDate(this.associatedDate, date)) {
        this.$emit('input', this.associatedDate)
        return;
      }

      if (this.isDate(date) || !isNaN(new Date(date).getTime())) {
        date = new Date(date);
      } else {
        date = new Date()
      }

      const year = date.getFullYear();
      const month = date.getMonth() + 1;

      // 修复日期补零问题
      this.selectedDate = this.patchZero(date)
      this.monthData = this.getMonthData(year, month);
    },
    getMonthData (year, month) {
      var ret = [];

      if (!year && year !== 0 || !month && month !== 0) {
        var today = new Date();
        year = today.getFullYear();
        month = today.getMonth() + 1;
      }

      var firstDay = new Date(year, month - 1, 1);
      var firstDayWeekDay = firstDay.getDay();
      if (firstDayWeekDay === 0) firstDayWeekDay = 7;

      year = firstDay.getFullYear();
      month = firstDay.getMonth() + 1;

      var lastDayOfLastMonth = new Date(year, month - 1, 0);
      var lastDateOfLastMonth = lastDayOfLastMonth.getDate();

      var perMonthDayCount = firstDayWeekDay - 1;

      var lastDay = new Date(year, month, 0);
      var lastDate = lastDay.getDate();

      var retItem = []

      for (var i = 0; i < 7 * 6; i++) {
        var date = i + 1 - perMonthDayCount;
        var showDate = date;
        var thisYear = year;
        var thisMonth = month;
        if (date <= 0) { // 上一月
          thisMonth = month - 1;
          showDate = lastDateOfLastMonth + date;
        } else if (date > lastDate) { // 下一月
          thisMonth = month + 1;
          showDate = showDate - lastDate;
        }

        if (thisMonth === 0) {
          thisYear--
          thisMonth = 12
        } else if (thisMonth === 13) {
          thisMonth = 1
          thisYear++
        }

        retItem.push({
          year: thisYear,
          month: thisMonth,
          date: date,
          fullDate: `${thisYear}-${thisMonth < 10 ? '0' + thisMonth : thisMonth}-${showDate < 10 ? '0' + showDate : showDate}`,
          showDate: showDate
        })

        if (retItem.length === 7) {
          ret.push(retItem)
          retItem = []
        }
      }

      return {
        year,
        month,
        days: ret
      };
    },
    changeMonth (direction) {
      let { year, month } = this.monthData;

      if (direction === 'prev') {
        month--
      } else if (direction === 'next') {
        month++
      }

      this.monthData = this.getMonthData(year, month)
    },
    isDisabled (date) {
      return this.disabledDate(date) || this.compareDate(this.associatedDate, date)
    },
    selectDate (date) {
      if (this.isDisabled(date)) return

      date = this.patchZero(date);
      this.$emit('change', date);
      this.$emit('input', date);
    },
    patchZero (date) { // 补 0 操作
      date = new Date(date);
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      month < 10 && (month = '0' + month);
      day < 10 && (day = '0' + day);
      return `${year}-${month}-${day}`;
    }
  },
  watch: {
    value () {
      this.initData();
    },
    associatedDate (newVal) {
      if (this.compareDate(newVal, this.value)) {
        this.selectDate(newVal)
      }
    }
  }
};
</script>

<style lang="scss">
@include b(ny-date-picker) {
  width: 296px;
  height: 352px;

  @include e(header) {
    height: 56px;
    line-height: 56px;
    text-align: center;
    background: #f9f9f9;

    span {
      padding: 0 12px;
      font-size: 20px;
    }
  }

  @include e(btn) {
    float: left;
    padding: 0 15px;
    font-size: 20px;
    color: #1d2b36;
    cursor: pointer;
  }

  @include e(next) {
    float: right;
  }

  @include e(body) {
    margin: 0 15px;
  }

  @include e(thead) {
    th {
      line-height: 45px;
      text-align: center;
    }
  }

  @include e(tbody) {
    td {
      @include is(last) {
        span {
          color: #b5c2ca;
          border-color: #f7f8fa;
        }
      }

      @include is(disabled) {
        span {
          color: #c4c8ca;
          background: #f8f8f8;
          border-color: #f7f8fa;
          cursor: not-allowed;
        }
      }

      @include is(associated) {
        span {
          color: #c4c8ca;
          background: #f8f8f8;
          border-color: #f7f8fa;
          cursor: not-allowed;
        }
      }
    }

    span {
      display: inline-block;
      width: 34px;
      height: 34px;
      margin: 2px;
      line-height: 32px;
      text-align: center;
      border: 1px solid #ebecf1;
      border-radius: 2px 2px;
      box-sizing: border-box;
      cursor: pointer;

      @include is(start) {
        border: 1px solid #def4ec;
        background: #def4ec;
      }

      @include is(end) {
        background: #f7dedb;
        border-color: #f7dedb;
      }
    }
  }
}
</style>
